import { render } from "./PwaConversionWithDatabase.vue?vue&type=template&id=1cc7cace&scoped=true"
import script from "./PwaConversionWithDatabase.vue?vue&type=script&lang=js"
export * from "./PwaConversionWithDatabase.vue?vue&type=script&lang=js"

import "./PwaConversionWithDatabase.vue?vue&type=style&index=0&id=1cc7cace&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc7cace"]])

export default __exports__